import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";

import styles from "../../../styles/AccountModals.module.css";
import { BASE_URL } from "../../../utils/constants";

import { handleApiError } from "../../../utils/handleApiError";

import Button from "../../../components/button-v1";

import AlertDialog from "../../../components/alert-dialogue";

const ActiveStaffModal = ({
  isOpen,
  onClose,
  staff_info,
  comp_renderer,
  current_render,
}) => {
  const modalRef = useRef(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpen, onClose]);

  // const handleCheckBoxChange = (e) => {
  //     const { name, checked } = e.target;
  //     setFormData((prev) => ({ ...prev, [name]: checked }));
  // };

  const activeStaff = async () => {
    const token = localStorage.getItem("authToken");
    const account_id = sessionStorage.getItem("acc_id");
    const url = `${BASE_URL}/accounts/${account_id}/staff/${staff_info.id}/edit/`;

    try {
      setLoading(true);
      const response = await axios.patch(
        url,
        { active: true },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setLoading(false);
      comp_renderer(!current_render);
      onClose();
      toast.success("Staff Activated successfully.");
    } catch (error) {
      setLoading(false);
      handleApiError(error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    activeStaff();
  };

  if (!isOpen) return null;

  return (
    <AlertDialog
      open={isOpen}
      setOpen={onClose}
      title="Activate External Staff"
      description={`Are you sure you want to activate ${staff_info.user.first_name} ${staff_info.user.last_name}`}
    >
      <Button variant="normal" size="default" onClick={onClose}>
        Cancel
      </Button>
      <Button loading={loading} onClick={handleSubmit}>
        Acitvate
      </Button>
    </AlertDialog>
  );
};

export default ActiveStaffModal;
